// Native Shopify variant checkout. No local prices, sample tax or shipping.
class GenesisCheckout extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController();
  const {signal} = this.controller;
  const form = this.querySelector('form');
  if (!form) return; // Both quote-only models use the native contact route.
  const select = form.elements.namedItem('id');
  const button = form.querySelector('button[type=submit]');
  const review = this.querySelector('[data-genesis-review]');
  const edit = this.querySelector('[data-genesis-edit]');
  let reviewing = false;
  const status = this.querySelector('[data-genesis-status]');
  const refresh = () => {
   const option = select.selectedOptions[0];
   this.querySelector('[data-genesis-price]').textContent = option?.dataset.price || '';
   const image = this.closest('.oh-genesis-checkout-layout').querySelector('[data-genesis-checkout-image] img');
   if (image && option?.dataset.image) {
    image.removeAttribute('srcset'); image.src = option.dataset.image;
    image.alt = option.dataset.title;
   }
   button.disabled = Boolean(this.pending) || !select.value || option.disabled;
  };
  const model = new URLSearchParams(location.search).get('model');
  const requested = [...select.options].find(option => option.dataset.model === model && !option.disabled);
  if (requested) select.value = requested.value;
  select.addEventListener('change', () => { status.textContent = ''; refresh(); }, {signal});
  const showBuild = () => {
   reviewing = false; review.hidden = true; select.disabled = false;
   button.textContent = 'Review build'; refresh(); select.focus();
  };
  edit.addEventListener('click', showBuild, {signal});
  form.addEventListener('submit', async event => {
   event.preventDefault();
   if (this.pending) return;
   const option = select.selectedOptions[0];
   if (!select.value || option.disabled) { select.focus(); return; }
   if (!reviewing) {
    reviewing = true; select.disabled = true; review.hidden = false;
    this.querySelector('[data-genesis-review-selection]').textContent = option.textContent;
    button.textContent = 'Add to cart'; review.querySelector('h2').focus(); return;
   }
   this.pending = true;
   button.disabled = true;
   select.disabled = true;
   edit.disabled = true;
   status.textContent = 'Adding your scooter…';
   try {
    const body = new FormData();
    body.set('id', select.value);
    body.set('quantity', '1');
    const response = await fetch(form.action.replace(/\/$/, '') + '.js', {method:'POST', body, headers:{Accept:'application/json'}, signal});
    const result = await response.json();
    if (!response.ok) {
     status.textContent = typeof result.description === 'string' ? result.description : 'This configuration could not be added. Please check its availability.';
     this.pending = false; edit.disabled = false; refresh(); return;
    }
    location.assign(this.dataset.cartUrl);
   } catch (error) {
    if (error.name !== 'AbortError') {
     status.textContent = 'We could not confirm the cart update. Check your cart before trying again.';
     const cart = document.createElement('a');
     cart.href = form.action.replace(/\/add\/?$/, ''); cart.textContent = 'View cart';
     status.append(' ', cart);
    }
    // A failed response can follow a successful write. Require a cart check,
    // rather than immediately offering a duplicate submission.
   }
  }, {signal});
  button.textContent = 'Review build'; refresh();
 }
 disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('oh-genesis-checkout')) customElements.define('oh-genesis-checkout', GenesisCheckout);
